import {SINGLETON_CLASS} from "@kta20-core/constants";
import {INetworkInterface} from "@kta20-core/interfaces/i-network-interface";

export interface IEventDispatcher {
    addEventListener(type: string, listener: any | null, options?: boolean | any): void;
    removeEventListener(type: string, callback: any | null, options?: any | boolean): void;
}

export class NetworkService {

    private static _inst:NetworkService;
    private _networkInterface:INetworkInterface;
    private _eventDispacher:IEventDispatcher;

    /**
     * Params required only at first service init.
     * @param netInt
     * @param eventDispatcher
     */
    static get(netInt?:INetworkInterface, eventDispatcher?:IEventDispatcher):NetworkService{
        if(!this._inst) {
            this._inst = new NetworkService();

            this._inst._networkInterface = netInt;
            this._inst._eventDispacher = eventDispatcher;
        }

        return this._inst;
    }

    hasNetwork():boolean {
        return  this._networkInterface ? this._networkInterface.onLine : false;
    }

    constructor() {
        if(NetworkService._inst) throw new Error(SINGLETON_CLASS);
    }

    addOnlineListener(handler:()=>void): void {
        this._eventDispacher.addEventListener('online', handler);
    }

    removeOnlineListener(handler:()=>void): void {
        this._eventDispacher.removeEventListener('online', handler);
    }

    addOfflineListener(handler:()=>void): void {
        this._eventDispacher.addEventListener('offline', handler);
    }

    removeOfflineListener(handler:()=>void): void {
        this._eventDispacher.removeEventListener('offline', handler);
    }

}